import React, { Suspense } from 'react';

import { SearchDialog } from '@atlassian/search-dialog/search-dialog';

import { SearchSkeletons } from '../../article-search-component/search-dropdown/search-skeletons';
import { HelpObjectSearchResults } from './help-object-search-results';

type HelpObjectSearchDropdownProps = {
	cloudId: string;
	helpCenterAri: string;
	inputWidth: number;
	queryWord: string;
};

export const HelpObjectSearchDropdown = ({
	inputWidth,
	...props
}: HelpObjectSearchDropdownProps): React.JSX.Element => {
	return (
		<SearchDialog
			/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
			style={{
				boxShadow: 'none',
				width: inputWidth,
			}}
			/* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */
		>
			<Suspense fallback={<SearchSkeletons />}>
				<HelpObjectSearchResults {...props} />
			</Suspense>
		</SearchDialog>
	);
};
